import React from 'react'
import style from "./Blocks.module.css";


const Blocks = ({ title, desc }) => {
  return (
    <div className={style.card}>
      <h4 className={style.title}>{title}</h4>
      <p className={style.desc}>{desc}</p>
    </div>
  )
}

export default Blocks